import { put } from "@redux-saga/core/effects";
import { uniqueId } from "lodash";

import { addFieldToLayout, replaceFieldInLayout, updateLayoutRequest } from "./../../layout/actionCreators";
import { addFieldToPage, replaceFieldId as replaceFieldIdInPage } from "./../../pages/actionCreators";

import { AddFieldResponse, FieldsService } from "./../../../services/fields";
import { addFieldSuccess, addFieldWithTempId } from "./../actionCreators";
import { AddFieldRequestActionType, FieldTypes } from "./../types";
import { initalMarker } from "./../../markers/actionCreaters";
import { addBulkOptionsSuccess } from "../../selectableOptions/actionCreaters";

export function* addFieldsSaga({ payload: { type, pageId, layout, data: fieldData = {} } }: AddFieldRequestActionType) {
    try {
        const tempId = uniqueId("tempId_");
        yield put(addFieldWithTempId({ type, id: tempId, data: fieldData }));

        yield put(addFieldToPage({ pageId, fieldId: tempId }));
        yield put(addFieldToLayout({ fieldId: tempId, fieldType: type, layout }));

        const {
            data: { data },
        }: AddFieldResponse = yield FieldsService.addField({
            type,
            pageId,
            ...fieldData,
        });
        const realFieldId = data._id;

        switch (type) {
            case FieldTypes.MAP: {
                yield put(initalMarker({ fieldId: realFieldId }));
                break;
            }
            case FieldTypes.CHECKBOX: {
                yield put(addBulkOptionsSuccess({ fieldId: realFieldId, options: data.options! }));
                break;
            }
            case FieldTypes.RADIO: {
                yield put(addBulkOptionsSuccess({ fieldId: realFieldId, options: data.options! }));
                break;
            }
            case FieldTypes.DROPDOWN: {
                yield put(addBulkOptionsSuccess({ fieldId: realFieldId, options: data.options! }));
                break;
            }
        }

        yield put(addFieldSuccess({ fieldId: realFieldId, tempId }));
        yield put(replaceFieldIdInPage({ fieldId: realFieldId, tempId }));
        yield put(replaceFieldInLayout({ fieldId: realFieldId, tempId }));
        yield put(updateLayoutRequest({}));
    } catch (error) {
        // yield put(Handle Error);
    }
}
